import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import UserSidebar from 'components/UserSidebar';
import UserEditForm from 'components/UserEditForm';

import { withData } from 'lib';
import { UserEditPageQuery } from '__generated__/UserEditPageQuery.graphql';

const query = graphql`
  query UserEditPageQuery($id: ID!) {
    user(id: $id) {
      name

      ...UserEditForm_user
      ...UserSidebar_user
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<UserEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/users', name: 'Vartotojai' }];

const UserEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { user } = usePreloadedQuery<UserEditPageQuery>(query, preloadedQuery);

  if (!user) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<UserSidebar user={user} />}
      breadcrumbs={[...breadcrumbs, { name: user.name }]}>
      <UserEditForm user={user} />
    </PageWithSidebar>
  );
};

export default withData<UserEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(UserEditPage);
